import { Subject } from 'rxjs';

export class UnauthorisedEventService {
  unauthorisedErrorObs = new Subject<boolean>();
}

// eslint-disable-next-line import/no-mutable-exports
export let unauthorisedEventService = new UnauthorisedEventService();

export function setUnAuthorisedEventService(service: UnauthorisedEventService) {
  unauthorisedEventService = service;
}
